module.exports = __webpack_public_path__ + "static/img-main-1c256443e17f4c7e0d40d579fd075777.jpg";